import { render, staticRenderFns } from "./modal-pane.vue?vue&type=template&id=bb88df54&scoped=true&"
import script from "./modal-pane.vue?vue&type=script&lang=js&"
export * from "./modal-pane.vue?vue&type=script&lang=js&"
import style0 from "./modal-pane.vue?vue&type=style&index=0&id=bb88df54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb88df54",
  null
  
)

export default component.exports